<template>
  <div class="d-flex justify-content-center align-items-center py-5">
    <b-spinner label="Loading" />
  </div>
</template>

<script>
// Permission-aware landing for /:clinicUrl/central. Loads the clinic's permission
// context, then redirects to the first page the caller can actually open:
//   dashboard.clinic.view -> ClinicDashboard (C_LEVEL clinic-wide, RDM scoped)
//   user.view.clinic      -> ClinicManagement
//   report.clinic.view    -> ClinicIncome (e.g. ACCOUNTANT with report access only)
// Falls back to user management on any error.
export default {
  name: "CentralEntry",
  async created() {
    const clinicUrl = this.$route.params.clinicUrl;
    let target = "ClinicManagement";
    try {
      await this.$store.dispatch("moduleUser/ensurePermissionContextFor", {
        clinicURL: clinicUrl,
      });
      const can = this.$store.getters["moduleUser/can"];
      if (can("dashboard.clinic.view")) {
        target = "ClinicDashboard";
      } else if (can("user.view.clinic")) {
        target = "ClinicManagement";
      } else if (can("report.clinic.view")) {
        target = "ClinicIncome";
      }
    } catch (err) {
      console.error("CentralEntry: failed to resolve landing page", err);
    }
    this.$router.replace({ name: target, params: { clinicUrl } });
  },
};
</script>
